import React from 'react'
import { PrimaryCta, Input, Icon } from 'components'
import { Paper, Typography, InputAdornment } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

function ReportByDni(_props) {
  const { title = 'DNI' } = _props

  const navigate = useNavigate()

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      search: '',
    },
  })

  const onSubmit = async (data) => {
    navigate(`${data.search}`)
  }

  return (
    <>
      <Paper className="mt-32 w-1/3 pt-0 p-8 mx-auto min-w-[30rem] flex flex-col justify-start items-center gap-8">
        <Typography
          variant="h2"
          component="p"
          className="text-primary"
          align="center"
        >
          {title}
        </Typography>
        <Typography variant="h3" component="p" className="" align="center">
          Ingresá el DNI que deseas buscar sin puntos ni espacios
        </Typography>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col justify-start items-center gap-12 w-full max-w-[18rem]"
          autoComplete="off"
        >
          <div className="w-full">
            <Input
              control={control}
              name="search"
              type="number"
              label={null}
              errors={errors.search}
              placeholder="Buscar DNI"
              endAdornment={
                <InputAdornment position="end">
                  <Icon icon={faSearch} />
                </InputAdornment>
              }
              validation={{
                required: 'Introduzca un DNI',
                min: {
                  value: 1000000,
                  message: 'El DNI parece no ser valido',
                },
                max: {
                  value: 99999999,
                  message: 'El DNI no puede tener más de 8 dígitos',
                },
              }}
            />
          </div>
          <PrimaryCta type="submit" disabled={!Boolean(watch('search'))}>
            Buscar
          </PrimaryCta>
        </form>
      </Paper>
    </>
  )
}

export default ReportByDni
